import { getMeta } from '@atlassian/eoc-fetch';

export function withReportingPrefix(input: string): string {
	// If current env is not opsgenie, we will add cloud id to base url of request.
	if ((window as any).__OG__) {
		return '/webapi' + input;
	}

	const cloudId = getMeta('ajs-cloud-id');
	if (cloudId) {
		return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
	}

	return input;
}

export const isTeamReportsUrl = (pathName: string): boolean =>
	pathName.startsWith('/jira/ops/teams/');
